import {checkWebviewResponse, createFuncHandler, defaultCall, isAppBuild} from "./helper";
import {WebviewApiError} from "./WebviewApiError";
import {webviewContext} from "./context";
import {webviewAppIds} from "../webview";

export function webviewGetWebApiInfoIsSupport(context = webviewContext()) {
  return isAppBuild(context, [
    {appId: webviewAppIds.photolabFree, ios: 12476},
    {appId: webviewAppIds.photolabProHD, ios: 12476},
    {appId: webviewAppIds.toonme, ios: 12476},
  ]);
}

export async function webviewGetWebApiInfo(extra, context = webviewContext()) {
  const funcName = "getWebApiInfo";

  if (!webviewGetWebApiInfoIsSupport(context)) {
    return WebviewApiError.unsupported(funcName).toWebviewResponse();
  }

  const funcHandler = createFuncHandler(context, funcName);
  const response = defaultCall(context, funcName, {
    func: funcHandler.name,
    web_extra: extra,
  }, {
    legacy: false,
  });

  return checkWebviewResponse(response || await funcHandler.promise, (res) => res);
}
